/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Conversion_CompleteInputs */

const en_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode conversion complete.`)
};

const fr_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion du timecode terminée.`)
};

const de_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcode-Konvertierung abgeschlossen.`)
};

const it_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversione del timecode completata.`)
};

const ru_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование временного кода завершено.`)
};

const es_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversión de código de tiempo completada.`)
};

const zh_cn2_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码转换完成。`)
};

const ja_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード変換が完了しました。`)
};

const hi_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड रूपांतरण पूर्ण हो गया।`)
};

const pt_pt2_timecode_conversion_complete = /** @type {(inputs: Timecode_Conversion_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversão de código de tempo concluída.`)
};

/**
* | output |
* | --- |
* | "Timecode conversion complete." |
*
* @param {Timecode_Conversion_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_conversion_complete = /** @type {((inputs?: Timecode_Conversion_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Conversion_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_conversion_complete(inputs)
	if (locale === "de") return de_timecode_conversion_complete(inputs)
	if (locale === "it") return it_timecode_conversion_complete(inputs)
	if (locale === "ru") return ru_timecode_conversion_complete(inputs)
	if (locale === "es") return es_timecode_conversion_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_conversion_complete(inputs)
	if (locale === "ja") return ja_timecode_conversion_complete(inputs)
	if (locale === "hi") return hi_timecode_conversion_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_conversion_complete(inputs)
	return en_timecode_conversion_complete(inputs)
});